var Md5Factory = /*#__PURE__*/function () {
  function Md5Factory(params) {
    var host = window.location.host;
    var protocol = window.location.protocol;
    this.settings = Object.assign({
      md5Worker: protocol + "//" + host + "/md5-worker.1596638689344.js",
      sparkMd5: protocol + "//" + host + "/spark-md5.js",
      maxWorker: 1,
      type: 'sample',
      // all: full file compute md5, sample: part of file compute md5
      onComplete: function onComplete() {}
    }, params || {});
    this.queue = [];
    this.workingCount = 0;
    this.maxWorker = this.settings.maxWorker || 1;
  }

  var _proto = Md5Factory.prototype;

  _proto.addFile = function addFile(file) {
    this.queue.push(file);

    if (this.workingCount < this.maxWorker) {
      this.compute();
    }
  };

  _proto.compute = function compute() {
    var _this = this;

    if (this.queue.length === 0) {
      return false;
    }

    this.workingCount++;
    var file = this.queue.shift();
    var worker = new window.Worker(this.settings.md5Worker);
    worker.postMessage(Object.assign({}, {
      file: file,
      type: this.settings.type,
      sparkMd5: this.settings.sparkMd5
    }));
    worker.addEventListener('message', function (e) {
      if (!e.data.err) {
        file.md5 = e.data.md5;
        _this.settings.onComplete && _this.settings.onComplete(file);
        _this.workingCount--;

        _this.compute();
      }

      worker.terminate();
    });
  };

  return Md5Factory;
}();

export default Md5Factory;